module.exports = __webpack_public_path__ + "dafb25f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/articles/leasing/no-credit-card.png
// module id = 3240
// module chunks = 21